import { Table, BackButton, Title, Pill, Dropdown, ScrollView } from '@chillibean/component-library/legacy';
import pluralize from 'pluralize';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { processData } from '../../../__util__/Table/formHelpers';
import ReportingSpinner from '../../../__util__/Table/ReportingSpinner';
import { Reporting } from '../../../api/reporting/reporting';
import useHttpRequest from '../../../CustomHooks/useHttpRequest/useHttpRequest';
import LogAndDisplayError from '../../../LogAndDisplayError/LogAndDisplayError';
import useNavigator from '../hooks/useNavigator';
import ExportModal from '../presentational/ExportModal';
import { selectInternalResult } from '../redux/internal.slice';

function FormReportTemplateReport() {
  const { formTemplateID } = useParams();
  const { accountId, sitesEnabled } = useSelector(selectInternalResult) || { sitesEnabled: false };
  const { goBack } = useNavigator();
  const {
    state: { status, data, error },
    fetchRequest,
  } = useHttpRequest();
  const moreDataRequester = useHttpRequest();

  const [tableHeaders, setTableHeaders] = useState([]);
  const [tableDataRows, setTableDataRows] = useState([]);
  const [tableDataReady, setTableDataReady] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const determineLoading = () => status !== 'resolved';

  useEffect(() => {
    if (!accountId) return;

    if (status === 'idle') {
      fetchRequest(Reporting.search({ form_template_id: formTemplateID }));
    }

    if (status === 'resolved') {
      const processedData = processData(data.results, { sitesEnabled });
      setTableHeaders([...processedData.headersReadyForTable]);
      setTableDataRows([...processedData.dataReadyForTable]);
      setTableDataReady(true);
    }
  }, [accountId, status]);

  useEffect(() => {
    if (moreDataRequester.state.status === 'resolved') {
      const processedData = processData(moreDataRequester.state.data.results).dataReadyForTable;
      setTableDataRows(tableDataRows.concat(processedData));
    }
  }, [moreDataRequester.state.status]);

  const fetchData = () => {
    const currentPage = parseInt(moreDataRequester.state.data?.page, 10) || parseInt(data.page, 10);
    const nextPage = currentPage + 1;
    moreDataRequester.fetchRequest(Reporting.search({ form_template_id: formTemplateID }, nextPage));
  };

  const hasMore = () => {
    if (data && tableDataReady) {
      const { hits, per_page: perPage } = data;
      return hits > perPage && tableDataRows.length < hits;
    }
    return false;
  };

  if (status === 'error') {
    return <LogAndDisplayError error={error} />;
  }

  return (
    <div className="single_column_container">
      <div className="header-wrapper-formReport">
        <div className="left-items">
          <BackButton onClickCallback={goBack} loading={determineLoading()} />
          <Title heading={data?.results[0]?.form_template.title} subheading="" loading={determineLoading()} />
          <Pill
            dataCount={String(data?.hits) || '0'}
            dataContext={pluralize('Form', data?.hits)}
            loading={determineLoading()}
          />
        </div>
        <div className="right-items">
          {!determineLoading() && (
            <Dropdown
              options={[
                {
                  label: 'Export data',
                  onSelect: () => {
                    setShowModal(!showModal);
                  },
                },
              ]}
              icon="kebab"
            />
          )}
        </div>
      </div>
      <div className="scroll-table-wrapper">
        <InfiniteScroll
          dataLength={tableDataRows.length}
          next={fetchData}
          scrollableTarget="scrollableDiv"
          hasMore={hasMore()}
          style={{ height: '100%' }}
        >
          <ScrollView idName="scrollableDiv">
            <Table
              headers={tableHeaders}
              tableData={tableDataRows}
              loading={!tableDataReady}
              hasMore={hasMore()}
              spinnerComponent={<ReportingSpinner />}
            />
          </ScrollView>
        </InfiniteScroll>
      </div>

      <ExportModal
        exportEndpoint="FORMS"
        formTemplateID={formTemplateID}
        setShowModal={setShowModal}
        showModal={showModal}
      />
    </div>
  );
}

export default FormReportTemplateReport;
